import React, { useRef } from "react";
import { useGLTF, Outlines } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/plots/05-PowerPlant.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }
  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube593.geometry}
        material={materials["00-Base3.001"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube595.geometry}
        material={materials["06-BuildingColor1"]}
        position={[0.11, 0.287, 0.261]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube597.geometry}
        material={materials["06-BuildingColor2"]}
        position={[-0.422, 0.501, 0.261]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube613.geometry}
        material={materials["06-WindowSill1"]}
        position={[-0.304, 0.225, 0.495]}
        scale={0.928}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube620.geometry}
        material={materials["04-RocksGray"]}
        position={[0.652, 0.172, -0.687]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube623.geometry}
        material={materials["02-BenchMetal"]}
        position={[-0.651, 0.104, 0.714]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube626.geometry}
        material={materials["03-FountainWhite2"]}
        position={[-0.422, 0.504, 0.261]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube632.geometry}
        material={materials["03-FountainWhite2"]}
        position={[0.668, 0.985, -0.486]}
        scale={0.87}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube722.geometry}
        material={materials["04-RocksGray"]}
        position={[0.012, 0.232, 0.473]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube723.geometry}
        material={materials["00-Grass1"]}
        position={[-0.651, 0.104, 0.714]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder104.geometry}
        material={materials["06-PowerPlantWhite"]}
        position={[0.818, 0.146, 0.22]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere053.geometry}
        material={materials["01-TreeGreen1"]}
        position={[-0.64, 0.125, 0.598]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane001.geometry}
        material={materials["07-WindowMat"]}
        position={[-0.304, 0.675, 0.495]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/05-PowerPlant.glb");